import { useMutation } from '@tanstack/react-query';

import { AgentFileSource } from '@Models';
import { bopsApi } from '@Network';

interface DownloadFileParams {
  conversationId: string;
  timestamp: string;
  fileName: string;
  source?: AgentFileSource;
}

export const useFileDownload = () => {
  const downloadFile = useMutation({
    mutationFn: async ({ conversationId, timestamp, fileName, source }: DownloadFileParams) => {
      // Get presigned URL from backend
      const response = await bopsApi.getFileDownloadUrl(conversationId, timestamp, fileName, false, source);

      // Create a temporary anchor element and trigger download
      const link = document.createElement('a');
      link.href = response.download_url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  });

  return {
    downloadFile,
  };
};

export default useFileDownload;
